<template>
  <p-permissions v-if="$hasPermission('users.read')" />
  <p-not-found v-else />
</template>

<script>
import Permissions from './../components/users/Permissions.vue';
import NotFound from './../components/NotFound.vue';

export default {
  components: {
    'p-permissions': Permissions,
    'p-not-found': NotFound
  }
};
</script>
